/**
 * Converts a Cordova File URI to a real Blob object
 * @param {string} uri - The file:/// path from the camera plugin
 * @returns {Promise<Blob>}
 */
export const getBlobFromUri = (uri) => {
    return new Promise((resolve, reject) => {
        if (!window.resolveLocalFileSystemURL) {
            reject(new Error("Cordova File Plugin not found"));
            return;
        }

        window.resolveLocalFileSystemURL(uri, (fileEntry) => {
            fileEntry.file((file) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Create the Blob from the ArrayBuffer
                    const blob = new Blob([new Uint8Array(reader.result)], { type: file.type });
                    // Attach the name manually so FilePond can use it
                    blob.name = file.name;
                    resolve(blob);
                };
                reader.onerror = (e) => reject(e);
                reader.readAsArrayBuffer(file);
            }, reject);
        }, reject);
    });
};